var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('baseInfo',{attrs:{"orderBean":_vm.orderBean}}),_c('tool',{attrs:{"orderBean":_vm.orderBean}}),(_vm.showNewPortray)?_c('OrderPortray'):_c('orderFeature')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }